import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { debounce } from "lodash";

const Searchbar = ({ onFilter, onSearch }) => {
  // Refs to store the debounced functions
  const debouncedSearchRef = useRef(null);
  const debouncedFilterRef = useRef(null);

  // Setup debounced functions and cleanup on unmount
  useEffect(() => {
    if (onSearch) {
      debouncedSearchRef.current = debounce((value) => onSearch(value), 500);
    }
    if (onFilter) {
      debouncedFilterRef.current = debounce((event) => onFilter(event), 500);
    }

    // Cleanup debounced functions on unmount
    return () => {
      if (debouncedSearchRef.current) debouncedSearchRef.current.cancel();
      if (debouncedFilterRef.current) debouncedFilterRef.current.cancel();
    };
  }, [onSearch, onFilter]);

  const handleChange = (e) => {
    e.persist();
    if (onSearch) {
      debouncedSearchRef.current(e.target.value);
    } else if (onFilter) {
      debouncedFilterRef.current(e);
    }
  };

  return (
    <StyledInput
      id="search-input"
      type="text"
      className="search-bar form-control"
      placeholder="&#x1F50E;  Search"
      onChange={handleChange}
    />
  );
};

const StyledInput = styled.input`
  margin-top: 10px;
  margin-right: 1%;
  height: 42px;
  font-family: "Nunito", "FontAwesome";
  border: 0;
  box-shadow: none !important;
  background: ${(props) =>
    props.theme.nightmode ? props.theme.dark_navy : "#fff"};
  color: ${(props) =>
    !props.theme.nightmode ? props.theme.dark_grey : "#fff"};
  &:focus {
    outline: none !important;
    border: 0;
  }
  &::placeholder {
    opacity: 0.8;
  }
`;

Searchbar.propTypes = {
  onFilter: PropTypes.func,
  onSearch: PropTypes.func
};

export default Searchbar;
